import {
  getAlbaranPdfById,
  postAlbaranGenerateExcel,
} from "api/Albaran.service"
import { TipoDocumentoComercialType } from "api/Types/TipoDocumentoComercial"
import { handleDirectDownloadExcel } from "common/context/DownloadFileProvider"
import notification from "common/utils/notification"
import { TFunction } from "i18next"
import fileDownload from "js-file-download"
import { Dispatch, SetStateAction } from "react"

export const handleDownloadPdfAlbaran = async (
  id: string,
  serie: string,
  t: TFunction
) => {
  try {
    const { data } = await getAlbaranPdfById(id)

    fileDownload(
      new Blob([data]),
      `${t("types.delivery")}${serie ? `_${serie}` : ""}.pdf`
    )

    notification.success({ body: `${t("successMsg.downloadDocument")}` })
  } catch (error) {
    notification.errorServidor({
      body: `${t("errorMsg.downloadDocument")}`,
    })
  }
}

export const handlerExportAlbaranesToExcel = async (
  tipoDocumentoComercial: TipoDocumentoComercialType,
  setIsLoadingExport: Dispatch<SetStateAction<boolean>>,
  t: TFunction
) => {
  try {
    setIsLoadingExport(true)
    const { data } = await postAlbaranGenerateExcel({ tipoDocumentoComercial })
    handleDirectDownloadExcel(data, `${t("types.delivery")}.xlsx`)
  } catch (err) {
    notification.errorServidor({
      body: `${t("crear.albaran.msg.downloadFail")}`,
    })
  } finally {
    setIsLoadingExport(false)
  }
}
